<template>
    <div class="Right-Content">
        <Header></Header>
        <div class="content">
            <router-view/>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Right-Content",
    }

</script>

<style lang="less" scoped>
    .Right-Content {
        height: 100vh;
        display: flex;
        flex-direction: column;

        .header {
            /*position: fixed;*/
            top: 0;
            height: 60px;
            width: 100%;
            flex-shrink: 0;
        }

        .content {
            width: 100%;
            flex: 1;
            overflow-y: auto;
        }
    }

    /* iPad 适配样式 */
    @media (max-width: 1024px) {
        .Right-Content {
            .header {
                height: 50px;
            }
        }
    }

</style>
